/*
* @Author: Mark Miller
* @Date:   2018-08-29 23:18:31
* @Last Modified by:   msmiller
* @Last Modified time: 2019-12-15 14:29:22
*
* Copyright (c) 2017-2018 Sharp Stone Codewerks / Mark S. Miller
*/

import { Controller } from "stimulus"

export default class extends Controller {

    connect() {
      var coverletter_id = this.data.get("id");
      // console.log("-=> coverletter_controller connected (" + coverletter_id + ")");
    }


    initialize() {
      $('#cover_letter_body').focusin(function() { $('.inject').prop("disabled", false); }); 
      $('#cover_letter_body').focusout(function(e) { 
        if ((e.relatedTarget == null) || (e.relatedTarget.tagName != 'BUTTON')) { $('.inject').prop("disabled", true); }
      }); 
    }

    inject_token() {
      var token = event.currentTarget.dataset['coverletterToken'];
      injectText('cover_letter[body]', token);
      $('.inject').prop('disabled', true);
    }


  }
  // console.log("-=> coverletter_controller loaded");

  function injectText(elemento, valor) {
    var elemento_dom = document.getElementsByName(elemento)[0];
    if (document.selection) {
      lemento_dom.focus();
      el = document.selection.createRange();
      el.text = valor;
      return;
    }
    if (elemento_dom.selectionStart || elemento_dom.selectionStart == "0") {
      var t_start = elemento_dom.selectionStart;
      var t_end = elemento_dom.selectionEnd;
      var val_start = elemento_dom.value.substring(0, t_start);
      var val_end = elemento_dom.value.substring(t_end, elemento_dom.value.length);
      elemento_dom.value = val_start + valor + val_end;
    } else {
      //elemento_dom.value+=valor; // If no cursor then appent to end 
    }
  }


